<template>
    <div class="home wow fadeInAnimated fadeIn">
        <swiper ref="mySwiper" :options="swiperOptionsThree" class="swiper">
            <swiper-slide>
                <img :src="bgImg" alt="" class="homeBack">
                    <div class="title">
                        <img :src="haojobLogo" alt="">
                        <ul class="tabItem">
                            <li @click="$router.push('/')" class="active">返回首页</li>
                        </ul>
                    </div>
                    <div class="centerFloat">
                        <div class="conterTitle">
                            <p class="haoojobTitle animate__animated animate__backInDown">把好工网装进口袋</p>
                            <p class="haoojobPerson animate__animated animate__backInDown">好工作 好工人 好工网</p>
                        </div>
                        <div class="allCode">
                            <div class="code">
                                <img :src="codeDownload" alt="" class="codeDownloadClass animate__animated animate__backInUp">
                                <p class="animate__animated animate__backInUp">扫码体验好工网劳务版APP</p>
                            </div>
                            <div class="code">
                                <img :src="miniProgressCode" alt="" class="codeDownloadClass animate__animated animate__backInUp">
                                <p class="animate__animated animate__backInUp">扫码找工作</p>
                            </div>
                        </div>
                    </div>
            </swiper-slide>
            <swiper-slide>
                <img :src="appdownloadBg" alt="" class="twoBack">
                <div class="content">
                    <div class="title">
                        <img :src="haojobLogoBlue" alt="">
                        <ul class="tabItem">
                            <li @click="$router.push('/')" class="active" style="color:#666666;">返回首页</li>
                        </ul>
                    </div>
                    <div class="centerFloatBlue">
                        <img :src="main2" alt="" class="animate__animated animate__slideInDown">
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="content">
                    <div class="title">
                        <img :src="haojobLogoBlue" alt="">
                        <ul class="tabItem">
                            <li @click="$router.push('/')" class="active" style="color:#666666;">返回首页</li>
                        </ul>
                    </div>
                    <div class="centerFloatBlue">
                        <img :src="main3" alt="">
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="content">
                    <div class="title">
                        <img :src="haojobLogoBlue" alt="">
                        <ul class="tabItem">
                            <li @click="$router.push('/')" class="active" style="color:#666666;">返回首页</li>
                        </ul>
                    </div>
                    <div class="centerFloatBlue" style="background:#FCF9FE;">
                        <img :src="main4" alt="">
                    </div>
                </div>
            </swiper-slide>
             <!-- 如果需要分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
import bgImg from '@/assets/download/appdownload-bg@2x.png'
import haojobLogoBlue from '@/assets/haoojoblogo.svg'
import main2 from '@/assets/download/appdownload-main2@2x.png'
import main3 from '@/assets/download/appdownload-main3@2x.png'
import main4 from '@/assets/download/appdownload-main4@2x.png'
import codeDownload from '@/assets/download/codeDownload.png'
import appdownloadBg from '@/assets/download/appdownload-bg2@2x.png'
import haojobLogo from '@/assets/haojob@2x.png'
import miniProgressCode from '@/assets/download/miniProgressCode.png'
export default {
    
    data(){
        return {
            codeDownload,
            bgImg,
            main2,
            main3,
            main4,
            haojobLogo,
            haojobLogoBlue,
            appdownloadBg,
            miniProgressCode,
            swiperOptionsThree: {
                speed: 900,//滑动速度
                mousewheel:true,//可以通过鼠标滑动
                direction : 'vertical',
                centeredSlides: true,
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                }
            }
        }
    },
    computed: {
        // swiper() {
        //     return this.$refs.mySwiper.$swiper
        // }
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    }
}
</script>
<style scoped lang="less">
    @media (min-width: 1920px) {
    body{font-size: 33px;}
    } 

    .twoBack{
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
    }
    .home{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .swiper{
        height: 100%;
        width: 100%;
    }
    .swiper-pagination{
        padding-right: 70px;
    }
    .homeBack{
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 111;
    }
    
    .centerFloatBlue{
        width: 100%;
        height: 100%;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        display: flex;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        img{
            width: 1300px;
            height: 750px;
            display: block;
        }
    }
    .centerFloat{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        overflow: hidden;
        z-index: 344;
        position: relative;
        .conterTitle{
            margin-top: 188px;
            .haoojobTitle{
                font-size:88px;
                font-weight:500;
                color:rgba(245,248,254,1);
                line-height: 92px;
                text-align: center;
            }
            .haoojobPerson{
                font-size:36px;
                line-height: 60px;
                text-align: center;
                font-weight:bold;
                color:rgba(245,248,254,1);
            }
        }
        .allCode{
            width: 697px;
            margin: 0 auto;
            height: auto;
            overflow: hidden;
            .code{
                overflow: hidden;
                margin: 0 auto;
                width: 290px;
                margin-top: 102px;
                float: left;
                .codeDownloadClass{
                    width: 269px;
                    height: 269px;
                    display: block;
                    margin: 0 auto;
                }   
                p{
                    font-size:24px;
                    font-weight:400;
                    color:#F5F8FE;
                    line-height:60px;
                    text-align: center;
                }
            }
            .code:last-child{
                float: right;
            }
        }
    }

    @media only screen and (max-width: 1024px) {
        body{font-size: 18px}
        .centerFloat{
            width: 640px;
            .conterTitle{
                margin-top:100px;
                .haoojobTitle{
                    font-size: 47px;
                    line-height: 50px;
                }
                .haoojobPerson{
                    margin-top: 20px;
                    font-size: 20px;
                    line-height: 32px;
                }
            }
            .allCode{
                width: 372px;
                .code{
                    width: 175px;
                    margin-top: 54px;
                    .codeDownloadClass{
                        width: 143px;
                        height: 143px;
                    }
                    p{
                        font-size:13px;
                        line-height:32px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 800px;
                height: 480px;
            }
        }
    } /*>=1024的设备*/

    @media only screen and (max-width: 1100px) and (min-width: 1024px) {
    body{font-size: 20px}
        .centerFloat{
            width: 687.5px;
            .conterTitle{
                margin-top:107.7px;
                .haoojobTitle{
                    font-size: 51px;
                    line-height: 54px;
                }
                .haoojobPerson{
                    margin-top: 26.93px;
                    font-size: 21px;
                    line-height: 35px;
                }
            }
            .allCode{
                width: 399px;
                .code{
                    width: 170px;
                    margin-top: 56px;
                    .codeDownloadClass{
                        width: 154px;
                        height: 154px;
                    }
                    p{
                        font-size:14px;
                        line-height:34px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 859.38px;
                height: 515.63px;
            }
        }
    } /*>=1100的设备*/
    @media only screen and (max-width: 1280px) and (min-width: 1100px) {
    body{font-size: 22px;}
        .centerFloat{
            width: 800px;
            .conterTitle{
                margin-top:125.33px;
                .haoojobTitle{
                    font-size: 59px;
                    line-height: 63px;
                }
                .haoojobPerson{
                    margin-top: 31px;
                    font-size: 24px;
                    line-height: 40px;
                }
            }
            .allCode{
                width: 465px;
                .code{
                    width: 200px;
                    margin-top: 68px;
                    .codeDownloadClass{
                        width: 179px;
                        height: 179px;
                    }
                    p{
                        font-size:16px;
                        line-height:40px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 1000px;
                height: 600px;
            }
        }
    } /*>=1280的设备*/

    @media only screen and (max-width: 1366px) and (min-width: 1280px) {
    body{font-size: 24px;}
        .centerFloat{
            width: 853.75px;
            .conterTitle{
                margin-top:133.75px;
                .haoojobTitle{
                    font-size: 63px;
                    line-height: 67px;
                }
                .haoojobPerson{
                    margin-top: 33px;
                    font-size: 26px;
                    line-height: 43px;
                }
            }
            .allCode{
                width: 496px;
                .code{
                    width: 215px;
                    margin-top: 72.57px;
                    .codeDownloadClass{
                        width: 191px;
                        height: 191px;
                    }
                    p{
                        font-size:18px;
                        line-height:43px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 1067.19px;
                height: 640.32px;
            }
        }
    }  

    @media only screen and (max-width: 1440px) and (min-width: 1366px) {
    body{font-size: 25px !important;}
        .centerFloat{
            width: 900px;
            .conterTitle{
                margin-top:141px;
                .haoojobTitle{
                    font-size: 66px;
                    line-height: 70px;
                }
                .haoojobPerson{
                    margin-top: 35px;
                    font-size: 27px;
                    line-height: 45px;
                }
            }
            .allCode{
                width: 523px;
                .code{
                    width: 225px;
                    margin-top: 76.5px;
                    .codeDownloadClass{
                        width: 202px;
                        height: 202px;
                    }
                    p{
                        font-size:18px;
                        line-height:45px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 1125px;
                height: 675px;
            }
        }
    } 

    @media only screen and (max-width: 1680px) and (min-width: 1440px) {
    body{font-size: 28px;}
        .centerFloat{
            width: 1050px;
            .conterTitle{
                margin-top:164.5px;
                .haoojobTitle{
                    font-size: 77px;
                    line-height: 81px;
                }
                .haoojobPerson{
                    margin-top: 41.13px;
                    font-size: 32px;
                    line-height: 53px;
                }
            }
            .allCode{
                width: 610px;
                .code{
                    width: 260px;
                    margin-top: 89px;
                    .codeDownloadClass{
                        width: 235px;
                        height: 235px;
                    }
                    p{
                        font-size:21px;
                        line-height:53px;
                    }
                }
            }
        }
        .centerFloatBlue{
            img{
                width: 1312.5px;
                height: 787.5px;
            }
        }
    } 
    
</style>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>